"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderEventFragment = void 0;
exports.orderEventFragment = `
    fragment orderEvent on OrderEvent {
        eventType
        doneAt
        doneBy
        note
    }
`;
//# sourceMappingURL=order-event.js.map